import React, { FC, useCallback, MouseEvent } from "react";


import { IntegrationsCard, IntegrationCardProp } from "./IntegrationsCard";

export const LACRMIntegrationCard: FC<IntegrationCardProp> = ({ appId, disabled, isLinked, isActive, onDisconnect }) => {

    const generateOAUTHClick = useCallback((url: string) => {
        return (e: MouseEvent<HTMLAnchorElement>): boolean => {

            if (url && !disabled) {
                window.open(url, "callout-option", "toolbar=0,status=0,width=1000,height=700");
            }
            // prevent default so the original href doesn't open
            e.preventDefault();
            return false;
        }
    }, [disabled]);

    const generateLACRMLink = useCallback(() => {
        const clientId = window?.xaStudioConfig?.integrations?.laCRM?.clientId;
        return `https://account.lessannoyingcrm.com/oauth/authorize.php?response_type=code&client_id=${clientId}&state=${appId}`
    }, [appId])
    const handleLACRMClick = generateOAUTHClick(generateLACRMLink());

    const handleDisconnectLACRM = useCallback(() => {
        if (typeof onDisconnect === "function") {
            onDisconnect();
        }
    }, [onDisconnect]);

    return (
        <IntegrationsCard
            disabled={disabled}
            imageUrl="/img/integrations/less-annoying-crm/icon-only-transparent.png"
            text="Less Annoying CRM"
            onClick={handleLACRMClick}
            href={generateLACRMLink}
            isActive={isActive}
            isLinked={isLinked}
            onDisconnect={typeof onDisconnect === "function" ? handleDisconnectLACRM : undefined}
        />
    )
}